import 'svgxuse';
import Stickyfill from 'stickyfilljs';
import modal from 'jquery-modal';
import $ from 'jquery';
import './components/alert-bar';
import './components/accordion';
import './components/filtered-grid';
import './components/gallery';
import './components/header';
import './components/hero-slider';
import './components/majik';
import './components/mobile-nav';
import './components/process-graph';
import './components/reportiv-graph';
import './components/smooth-scroll';
import './components/stat-card';
import './components/timeline';
import './components/typed-text';
import './vendors/scrollspy';
import './vendors/jquery.matchHeight';
import './vendors/readingtime';
import './components/conversation';
import './components/form';
import './components/loadmore';
import './components/sticky-sidebar';
import './components/logo-module';
import './components/objective-card';
import './components/approach-graph';
import './components/tabs';
import './components/logo-slider';

// Hamburger icon
$( '.js-hamburger-icon' ).on( 'click', function() {
	$( this ).toggleClass( 'is-active' );
} );

// Disable Right click on video
$( function() {
	$( 'video' ).on( 'contextmenu', function() {
		return false;
	} );
} );

$( 'a[data-modal]' ).on( 'click', function() {
	$( this ).modal( {
		fadeDuration: 250,
	} );
	return false;
} );

// Stop HTML5 video on modal close

$( '.modal' ).on( $.modal.BEFORE_CLOSE, function() {
	var htmlVideo = $( this ).find( 'video' );
	if ( htmlVideo.length > 0 ) {
		htmlVideo.get( 0 ).pause();
	}
} );

// Open Modal from URL hash if exists
function hashModal() {
	if ( window.location.hash ) {
		var hash = window.location.hash;

		if ( $( hash ).hasClass( 'modal' ) ) {
			$( hash ).modal( 'toggle' );
		}
	}
}

$( window ).on( 'load', function() {
	hashModal();
} );

$( window ).on( 'hashchange', function() {
	hashModal();
} );

// Scrollspy
$( 'body' ).scrollspy( {
	target: '.js-scrollspy-nav',
} );

// Position sticky polyfill
var elements = document.querySelectorAll(
	'.c-page-nav, .c-sticky-sidebar__content, .c-header--sticky'
);
Stickyfill.add( elements );

// Reading time on post pages
$( function() {
	$( '.js-reading-time' ).readingTime( {
		readingTimeTarget: $( '.js-reading-time-eta' ),
	} );
} );

document.addEventListener( 'DOMContentLoaded', function() {
	const toggleModalBtns = document.querySelectorAll( '.js-toggle-modal' );
	const body = document.querySelector( 'body' );

	toggleModalBtns.forEach( function( btn ) {
	  btn.addEventListener( 'click', function() {
			const modalId = this.dataset.target;
			const modal = document.getElementById( modalId );

			modal.classList.toggle( 'is-active' );
			body.classList.toggle( 'has-modal' );
	  } );
	} );
} );

const toggleChallengeSolution = document.querySelectorAll( '.js-toggle-challenge-solution-option' );

if ( toggleChallengeSolution ) {
	toggleChallengeSolution.forEach( function( element ) {
		element.addEventListener( 'click', function() {
			const attr = element.getAttribute( 'data-option' );
			const target = document.querySelector( '.c-challenge-solution' );
			const animation = document.querySelector( '.js-dots-animation' );

			if ( target.classList.contains( 'has-challenge' ) && attr === 'has-challenge' ) {
				return;
			}

			if ( target.classList.contains( 'has-solution' ) && attr === 'has-solution' ) {
				return;
			}

			if ( target.classList.contains( 'has-challenge' ) ) {
				target.classList.replace( 'has-challenge', 'has-solution' );
				animation.classList.add( 'is-animated' );
			} else {
				target.classList.replace( 'has-solution', 'has-challenge' );
				animation.classList.remove( 'is-animated' );
			}

			toggleChallengeSolution.forEach( function( el ) {
				el.classList.remove( 'is-selected' );
			} );

			element.classList.add( 'is-selected' );
		} );
	} );
}
